import React from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronRight, faPenNib, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { faCircle } from '@fortawesome/free-regular-svg-icons'
import { CompetencyStatus } from '../../utils/growth-wheel-utils'

interface CompetencyViewCardProps {
  title: string
  description: string
  selfLevel?: string | number | null
  guidedLevel?: string | number | null
  showSelfAssessed?: boolean
  showGuided?: boolean
  status?: CompetencyStatus
  onClick?: () => void
}

const CompetencyViewCard = ({
  title,
  description,
  selfLevel,
  guidedLevel,
  showSelfAssessed = false,
  showGuided = false,
  status = CompetencyStatus.PENDING,
  onClick,
}: CompetencyViewCardProps) => {
  const statusIcon = status === CompetencyStatus.COMPLETE ? faCheckCircle : faCircle
  const statusClassName =
    status === CompetencyStatus.COMPLETE ? 'gw-competency-view-status-icon' : 'gw-competency-view-status-icon gw-competency-view-status-icon--pending'

  const selfLevelComponent = () => {
    return selfLevel !== null &&
      <div className="gw-competency-view-level">
        <span className="gw-competency-view-level-label">Self:</span>
        <span className="gw-competency-view-level-value">Level {selfLevel}</span>
      </div>
  }

  const guidedLevelComponent = () => {
    return guidedLevel !== null &&
      <div className="gw-competency-view-level">
        <span className="gw-competency-view-level-label">Guided:</span>
        <span className="gw-competency-view-level-value gw-competency-view-level-value--guided">Level {guidedLevel}</span>
      </div>
  }

  const showGuidedComponent = () => {
    return showGuided &&
      <span className="gw-competency-view-chip gw-competency-view-chip--guided">
        <FontAwesomeIcon icon={faPenNib} className="gw-competency-view-chip-icon" />
        Guided
      </span>
  }

  const showSelfAssessedComponent = () => {
    return showSelfAssessed &&
      <span className="gw-competency-view-chip gw-competency-view-chip--self">
        Self-assessed
      </span>
  }

  return (
    <div
      className="card shadow-sm gw-competency-view-card"
      role={onClick ? 'button' : undefined}
      onClick={onClick}
    >
      <div className="card-body gw-competency-view-body">
        <div className="d-flex align-items-start gap-3">
          <FontAwesomeIcon icon={statusIcon} className={statusClassName} />
          <div className="flex-grow-1">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <h6 className="gw-competency-view-title mb-0">{title}</h6>
              {showSelfAssessedComponent()}
              {showGuidedComponent()}
            </div>
            <p className="gw-competency-view-description mb-1">{description}</p>
            <div className="d-flex align-items-center gap-3 flex-wrap">
              {selfLevelComponent()}
              {guidedLevelComponent()}
            </div>
          </div>
          <FontAwesomeIcon icon={faChevronRight} className="gw-competency-view-chevron" />
        </div>
      </div>
    </div>
  )
}

export default CompetencyViewCard
